<template>
  <va-card :title="$t('menu.vehicle_bays') + ' ' + this.$route.params.vehicle">
    <va-modal
      v-model="dialog"
      title="Mover produto"
      :message="`Selecione a quantidade e pra onde desejar mover o produto.`"  
      hideDefaultActions
      size="large"
    >
      <div>
        {{ sortedProduct.product_name }}
        <!-- <br> {{ sortedProduct.quantity }} {{ sortedProduct.box ? 'CX' : 'UN' }} -->
      </div>

      <div class="row">
        <div class="flex md6">
          <br>
          <va-select
            :label="$t('forms.selects.selectBay')"
            v-model="newBay"
            keyBy="id"
            textBy="bay_name"
            :options="vehicleBays"
          />
        </div>

        <!-- <div class="flex md6">
          <va-select
            :label="$t('forms.selects.selectLayer')"
            v-model="newLayer"
            keyBy="name"
            textBy="name"
            :options="listLayers"
          />
        </div> -->
      </div>

      <div>
        <va-input
          v-model="newQuantity"
          placeholder="QUANTIDADE"
        />
      </div>

      <va-button
        color="green"
        class="ml-2 right"
        @click="moveProduct(atualBay, newBay, sortedProduct, newQuantity)">
        Mover
      </va-button>

      <va-button
        color="secondary"
        class="ma-0"
        @click="cleanMoveProduct()"
      >
        Cancelar
      </va-button>
    </va-modal>

    <va-modal
        v-model="showRepalletizeLoad"
        size="small"
        :title="$t('modal.confirm')"
        :message="$t('modal.messageConfirmRepalletizeLoad')"
        hideDefaultActions
        :color="this.$themes.secondary"
      >
      <va-select
        :label="$t('forms.selects.palletizationTypes')"
        v-model="palletizationType"
        keyBy="id"
        textBy="name"
        :options="palletizationTypes"
      />

      <va-select
        :label="$t('forms.selects.sortTypes')"
        v-model="sortType"
        keyBy="id"
        textBy="name"
        :options="sortTypes"
      />
      <va-button
        color="danger"
        class="ma-2"
        @click="reloadSortAndPalletizationTypes(), showRepalletizeLoad = false">
        {{$t('modal.cancel')}}
      </va-button>

      <va-button
        color="green"
        class="ma-2"
        @click="repalletize_or_reorder_load(loadID, sortType.id, palletizationType.id), showRepalletizeLoad = false">
        {{$t('modal.confirm')}}
      </va-button>
    </va-modal>

    <div class="row">
      <div class="flex xs2">
        <va-button
          medium
          inline
          color="#ff842b"
          text-align="left"
          icon="fa fa-chevron-left"
          class="ma-2"
          :to="{ name: 'load_palletizing', params: {
            current_page: this.$route.params.current_page, 
            searchName: this.$route.params.searchName, 
            delivery_date: this.$route.params.delivery_date, 
            perPage: this.$route.params.perPage }
            }"
        >
          {{ $t("menu.back") }}
        </va-button>
      </div>

      <div class="flex xs2">
        <va-toggle
          medium
          v-model="enabled"
          color="secondary"
          label="Editar"
          v-if="status === 'Verificação de paletização'"
        />
      </div>

      <div class="flex xs2">
        <va-button
          medium
          inline
          color="green"
          icon="fa fa-edit"
          class="ma-0"
          @click="save(vehicleBays)"
          v-if="status === 'Verificação de paletização'"
        >
          {{ $t('menu.save') }}
        </va-button>
      </div>

      <div class="flex xs2">
        <va-button
          medium
          inline
          color="danger"
          icon="fa fa-times"
          class="ma-0"
          :disabled="!enabled"
          @click="readItems"
          v-if="status === 'Verificação de paletização'"
        >
          {{ $t('menu.reset_edit') }}
        </va-button>
      </div>

      <div class="flex xs2">
        <va-button
          medium
          inline
          color="secondary"
          icon="fa fa-times"
          class="ma-0"
          @click="showRepalletizeLoad = true"
          v-if="status === 'Verificação de paletização'"
        >
          {{ $t('menu.repalletize_load') }}
        </va-button>
      </div>

      <div v-show="!loading" class="flex xs12 md12">
        <va-card>
          <div class="row row-separated">
            <div class="flex xs2">
              <p class="display-2 mb-1 text--center" :style="{color: this.$themes.secondary}">{{ this.productsWeight }}</p>
              <p class="text--center mb-1">{{$t('dashboard.info.productsWeight')}}</p>
            </div>
            <div class="flex xs2">
              <p class="display-2 mb-1 text--center" :style="{color: this.$themes.secondary}">{{ this.weightCapacity }}</p>
              <p class="text--center no-wrap mb-1">{{$t('dashboard.info.vehicleWeightCapacity')}}</p>
            </div>
            <div class="flex xs2">
              <p class="display-2 mb-1 text--center" :style="{color: this.$themes.secondary}">{{ this.volumeCapacity }}</p>
              <p class="text--center no-wrap mb-1">{{$t('dashboard.info.vehicleVolumeCapacity')}}</p>
            </div>
            <div class="flex xs2">
              <p class="display-2 mb-1 text--center" :style="{color: this.$themes.secondary}">{{ this.cubageCapacity }}</p>
              <p class="text--center no-wrap mb-1">{{$t('dashboard.info.vehicleCubageCapacity')}}</p>
            </div>
            <div class="flex xs2">
              <p class="display-2 mb-1 text--center" :style="{color: this.$themes.secondary}">{{ this.quantityProducts }}</p>
              <p class="text--center mb-1">{{$t('dashboard.info.quantityProducts')}}</p>
            </div>
            <div class="flex xs2">
              <p class="display-2 mb-1 text--center" :style="{color: this.$themes.secondary}">{{ this.quantityClients }}</p>
              <p class="text--center mb-1">{{$t('dashboard.info.quantityClients')}}</p>
            </div>
          </div>
        </va-card>
      </div>

    </div>

    <div v-show="loading" class="text--center pb-4">
      <div class="flex-center spinner-box">
        <slot name="loading">
          <spring-spinner
            slot="loading"
            :animation-duration="currentDuration"
            :is="spload.name"
            :color="spinnersColor"
            :size="config.size"
          />
        </slot>
      </div>
    </div>

    <div v-show="!loading" class="row">
      <div class="flex xs4 lg4">
        <va-accordion>
          <va-collapse customHeader>
            <span slot="header" style="text-align: center; font-weight: bold">
              <va-button 
                style="width: 100%" 
                color="secondary"
                ref="collapses"
              >
                Baia Externa
              </va-button>
            </span>
            <div slot="body">
              <div>
                <draggable
                  class="list-group"
                  :list="externalBay"
                  group="bays"
                  :disabled="!enabled"
                  @change="calcPercents()"
                >
                  <template>
                    <va-item 
                      v-for="product in externalBay"
                      :key="product.id"
                      class="list-group-item"
                      :style="cssVars"
                    >
                      <va-item-section avatar>
                        <va-popover
                          placement="bottom"
                          title="Detalhes do Embalagem"
                          :message=packageDetails(product.ballast,product.height,product.weight,product.full_pallet)
                          color="info"
                        >
                          <va-avatar>
                            <img :src="product.image">
                          </va-avatar>
                        </va-popover>  
                      </va-item-section>

                      <va-item-section>
                        <va-popover
                          placement="bottom"
                          title="Detalhes do Produto"
                          :message=productDetails(product.product_group_name)
                          color="info"
                        >
                          <va-item-label>
                            {{ product.product_name }}
                          </va-item-label>
                        </va-popover>  
                      </va-item-section>

                      <va-item-section side>
                        <va-item-label>
                          {{ product.quantity }}
                        </va-item-label>
                      </va-item-section>
                      <div class="card_row">
                        <div class="card_column_right">
                          <va-button
                            v-if="enabled" 
                            inline 
                            small 
                            color="info"
                            icon="fa fa-pencil"
                            class="ma-0"
                            @click="openModal(bay, product)"
                          >
                            {{ $t('tables.move') }}
                          </va-button>
                        </div>
                      </div>
                    </va-item>
                  </template>
                </draggable>
              </div>
            </div>
          </va-collapse>
        </va-accordion>
      </div>
    </div>

    <div v-show="!loading" class="row">
      <div v-for="(bay, i) in vehicleBays" :key="i" class="flex xs4 lg4">
        <va-accordion>
          <va-collapse customHeader>
            <span slot="header" style="text-align: center; font-weight: bold">
              <va-button 
                style="width: 100%" 
                color="secondary"
                ref="collapses"
              >
                {{ $t("lists.bay_label") }} {{ bay.bay_name }} |
                {{ (bay.bay_percentage * 100).toFixed(2) + '%' }}
              </va-button>
            </span>
            <div slot="body">
              <div
                class="flex xs12"
              >
                <va-select
                  :label="$t('forms.selects.selectPalletType')"
                  v-model="bay.pallet_type"
                  keyBy="id"
                  textBy="name"
                  :options="palletTypes"
                  :disabled="!enabled"
                />
              </div>
              <draggable
                class="list-group"
                :list="bay.products"
                group="bays"
                :disabled="!enabled"
                @change="calcPercents()"
              > 
                <template>
                  <va-item 
                    v-for="product in bay.products"
                    :key="product.id"
                    class="list-group-item"
                    :style="cssVars"
                  >
                    <va-item-section avatar>
                      <va-popover
                        placement="bottom"
                        title="Detalhes do Embalagem"
                        :message=packageDetails(product.ballast,product.height,product.weight,product.full_pallet)
                        color="info"
                      >
                        <va-avatar>
                          <img :src="product.image">
                        </va-avatar>
                      </va-popover>  
                    </va-item-section>

                    <va-item-section>
                      <va-popover
                        placement="bottom"
                        title="Detalhes do Produto"
                        :message=productDetails(product.product_group_name)
                        color="info"
                      >
                        <va-item-label>
                          {{ product.product_name }}
                        </va-item-label>
                      </va-popover>
                    </va-item-section>

                    <va-item-section side>
                      <va-popover
                        placement="bottom"
                        title="Percentual do Produto"
                        :message=productPercentageDetail(product.product_percentage)
                        color="info"
                      >
                        <va-item-label>
                          {{ product.quantity }}
                        </va-item-label>
                      </va-popover>
                    </va-item-section>
                    <div class="card_row">
                      <div class="card_column_right">
                        <va-button
                          v-if="enabled" 
                          inline 
                          small 
                          color="info"
                          icon="fa fa-pencil"
                          class="ma-0"
                          @click="openModal(bay, product)"
                        >
                          {{ $t('tables.move') }}
                        </va-button>
                      </div>
                    </div>
                  </va-item>
                </template>
              </draggable>
            </div>
          </va-collapse>
        </va-accordion>
      </div>
    </div>
  </va-card> 
</template>

<script>
import SortedProductAPI from '@/services/SortedProductAPI'
import PalletizedProductsAPI from '@/services/PalletizedProductsAPI'
import LoadAPI from '@/services/LoadAPI'
import PalletTypeAPI from '@/services/PalletTypeAPI'
import PalletizationTypesAPI from '../../../services/PalletizationTypesAPI'
import SortTypesAPI from '../../../services/SortTypesAPI'
import LoadPalletizingAPI from '@/services/LoadPalletizingAPI'
import draggable from 'vuedraggable'
import * as spinners from 'epic-spinners'
import { showError } from '@/global'

export default {
  name: 'grid',
  components: {
    draggable,
    ...spinners,
  },
  data () {
    return {
      data: [],
      loadID: '',
      status: '',
      enabled: false,
      loading: false,
      dialog: false,
      collapse: false,
      config: {
        size: 150,
        group: 4,
        duration: 3000,
      },
      spinnersColor: this.$themes.secondary,
      currentDuration: 3000,
      vehicleBays: '',
      productsWeight: '',
      quantityProducts: '',
      quantityClients: '',
      weightCapacity: '',
      volumeCapacity: '',
      cubageCapacity: '',
      atualQuantity: '',
      newQuantity: '',
      atualBay: '',
      newBay: '',
      atualLayer: '',
      newLayer: '',
      sortedProduct: {},
      externalBay: [],
      loadStatus: '',
      validate: '',
      palletTypes: [],
      dragStyle: {
        backgroundColor: this.$themes.secondary,
        fontWeight: 'bold'
      },
      collapseButton: '',
      showRepalletizeLoad: false,
      showReorderLoad: false,
      palletizationType: {
        id: '',
        name: ''
      },
      sortType: {
        id: '',
        name: ''
      },
      palletizationTypes: [],
      sortTypes: [],
      palletizationTypeSelected: '',
    }
  },
  mounted () {
    this.readItems();
  },
  computed: {
    computedStyle () {
      return {
        backgroundColor: this.$themes.secondary,
      }
    },
    cssVars() {
      return {
        '--secondary-color': this.$themes.secondary,
        '--primary-color': this.$themes.primary,
      }
    },
    spload () {
      return spinners.SelfBuildingSquareSpinner
    },
  },
  methods: {
    async reloadSortAndPalletizationTypes() {
      await LoadAPI.getLoadById(this.loadID).then( response => {
        this.palletizationType = response.data.load.palletization_type
        this.sortType = response.data.load.sort_type
      })
    },

    readItems() {
      this.loadID = this.$route.params.loadID
      this.loading = true

      PalletizationTypesAPI.getAllPalletizationTypes().then(response => {
        this.palletizationTypes = response.data.palletization_types
      })

      SortTypesAPI.getAllSortTypes().then(response => {
        this.sortTypes = response.data.sort_types
      })

      LoadAPI.getBayProducts(this.loadID).then(
        response => {
          this.vehicleBays = response.data.bays
          this.productsWeight = response.data.products_weight
          this.quantityProducts = response.data.quantity_products
          this.quantityClients = response.data.quantity_clients
          this.weightCapacity = response.data.vehicle_weight_capacity
          this.volumeCapacity = response.data.vehicle_volume_capacity
          this.cubageCapacity = response.data.vehicle_cubage_capacity
          this.loading = false
          this.status = response.data.status
          this.loading = false
        }
      )

      PalletTypeAPI.getAll().then( response => {
        this.palletTypes = response.data.pallet_types
      })

      LoadAPI.getLoadById(this.loadID).then( response => {
        this.palletizationType = response.data.load.palletization_type
        this.sortType = response.data.load.sort_type
      })

      this.enabled = false
      this.externalBay = []
      this.calcPercents()      
    },
    productDetails(productGroupName) {
      return 'Grupo: ' + productGroupName
    },
    packageDetails(ballast, height, weight, fullPallet) {
      return 'L: ' + ballast + 'cx' + ', A: ' + height + 'cm' + ', P:' + weight + 'Kg' + ' PC: ' + fullPallet + 'cx'
    },
    productPercentageDetail(productPercentage) {
      productPercentage = productPercentage * 100
      return productPercentage + '%'
    },
    openModal(atualBay, sortedProduct){
      this.dialog = true;
      this.atualBay = atualBay;
      this.sortedProduct = sortedProduct;
    },
    refreshCollapses() {
      const bays = this.$refs.collapses
      bays.forEach(bay => {
        bay.$el.click()
        bay.$el.click()
      });
    },
    moveProduct(atualBay, newBay, sortedProduct, newQuantity){

      var newVehicleBays = []
      var newSortedProduct = {}
      this.vehicleBays.forEach(bay => {

        var newVehicleBay = {
          id: bay.id,
          pallet_type: bay.pallet_type,
          load_id: bay.load_id,
          bay_name: bay.bay_name,
          bay_type_name: bay.bay_type_name,
          width: bay.width,
          height: bay.height,
          length: bay.length,
          bay_percentage: bay.bay_percentage,
          products: []
        }
        newVehicleBays.push(newVehicleBay)
        if (bay.id === atualBay.id) {
          bay.products.forEach(product => {
            if (product.id === sortedProduct.id) {
              var productQuantity = product.quantity - newQuantity
              product.quantity = productQuantity
              product.product_percentage = (productQuantity / product.ballast)
            }
            newSortedProduct = {
              id: product.id,
              quantity: newQuantity,
              delivery_sequence: product.delivery_sequence,
              product_percentage: (newQuantity / product.ballast),
              layer_picker: product.layer_picker,
              box: true,
              product_id: product.product_id,
              product_name: product.product_name,
              image: product.image,
              quantity: newQuantity,
              client_id: product.client_id,
              client_name: product.client_name,
              package_name: product.package_name,
              ballast: product.ballast,
              height: product.height,
              weight: product.weight,
              full_pallet: product.full_pallet
            }
            newVehicleBay.products.push(product)
          });
        } else if (bay.id === newBay.id) {
          bay.products.forEach(product => {
            newVehicleBay.products.push(product)
            newVehicleBay.products.push(newSortedProduct)
          })
        } else {
          bay.products.forEach(product => {
            newVehicleBay.products.push(product)
          })
        };
      });

      this.vehicleBays = newVehicleBays;
      this.dialog = false;
      this.newBay = '';
      this.newQuantity = '';
      this.calcPercents();
    },
    cleanMoveProduct(){
      this.dialog = false;
      this.newBay = '';
      this.newQuantity = '';
    },
    calcPercents() {
      this.refreshCollapses()
      this.vehicleBays.forEach(bay => {
        var bayPercentage = 0
        bay.products.forEach (product => {
          bayPercentage += (product.quantity / product.full_pallet)
        });
        bay.bay_percentage = bayPercentage
      });
    },
    save(data) {

      this.verifyData()
      this.calcPercents()

      if (this.validate) {

        this.enabled = false
        this.loading = true

        SortedProductAPI.savePalletizedProducts(data).then(response => {
        
          this.showToast(response.data.message, {
            icon: 'fa-thumbs-o-up',
            position: 'top-right',
            duration: 5000,
          })

          this.readItems()
          
        }).catch(e => {
          this.showToast(e.response.data.error, {
            icon: 'fa-thumbs-o-down',
            position: 'top-right',
            duration: 5000,
          })
      });

      } else {
        this.showToast(this.$t('toast.unableToSavePalletization'), {
          icon: 'fa-exclamation',
          position: 'top-right',
        })
      }
    },
    verifyData() {
      this.validate = true
      if (this.externalBay.length > 0) {
        this.showToast(this.$t('toast.productsInTheOuterBay'), {
          icon: 'fa-thumbs-o-down',
          position: 'top-right',
        })
        this.validate = false
      }

      this.vehicleBays.forEach(bay => {
        console.log(bay.bay_percentage)
        if ((bay.bay_percentage * 100) > 100) {
          this.showToast(this.$t('toast.layerPercentageAbove100'), {
            icon: 'fa-thumbs-o-down',
            position: 'top-right',
          })
          this.validate = false  
        }
        bay.products.forEach(product => {
          if (product.quantity === 0) {
            this.showToast(this.$t('toast.productWithZeroQuantity'), {
              icon: 'fa-thumbs-o-down',
              position: 'top-right',
            })
            this.validate = false
          }
        })
      });
      this.validate = true
    },

    repalletize_or_reorder_load(load_id, sort_type, palletization_type){
      LoadPalletizingAPI.repalletize_or_reorder_load(load_id, sort_type, palletization_type).then(response => {
        this.showToast(response.data.message, {
          icon: 'fa-thumbs-o-up',
          position: 'top-right',
          duration: 5000,
        })
        this.readItems()
      }).catch(e => {
        this.showToast(e.response.data.error, {
          icon: 'fa-thumbs-o-down',
          position: 'top-right',
          duration: 5000,
        })
      });
    },
  },
}
</script>
 
<style lang="scss">
  .list-group-item {
    cursor: grab;
    background-color: #f8f8ff;
    margin-top: 5px;
    border-radius: 10px;
  }

  .list-group-item :hover {
    background-color: var(--secondary-color);
    color: #fff;
    border-radius: 10px;
  }

  .list-group-item i {
    cursor: grabbing;
  }
  .bold {
    font-weight: bold;
  }
  .card_column {
    float: left;
    width: 50%;
  }
  .card_column_left {
    float: left;
    width: 35%;
  }
  .card_column_right {
    float: left;
    width: 65%;
  }
  // /* Clear floats after the columns */
  .card_row:after {
    content: "";
    display: table;
    clear: both;
  }
</style>
